import { AgentProject } from '../agent-project/agent-project.js'
import { ADK_VERSION, formatCode } from './utils.js'
import { createFile } from '../utils/fs.js'
import path from 'path'

export async function generateTriggerTypes(project: AgentProject): Promise<void> {
  // Get trigger event subscriptions from definitions
  const triggerEvents: Record<string, string[]> = {}

  for (const trigger of project.triggers) {
    // The trigger definition should already contain the events array
    triggerEvents[trigger.definition.name] = trigger.definition.events || []
  }

  // Generate Triggers type that maps trigger names to their properties
  const triggersType = Object.entries(triggerEvents)
    .map(([triggerName, events]) => {
      let eventType = 'never'
      if (events.length > 0) {
        eventType = events.map((event) => `Event<"${event}">`).join(' | ')
      }
      return `  "${triggerName}": {
    events: [${events.map((e) => `"${e}"`).join(', ')}];
    event: ${eventType};
  };`
    })
    .join('\n')

  const content = `
////////////////////////////////////////////////////////
// DO NOT EDIT THIS FILE DIRECTLY
// This file is auto-generated from the Botpress ADK
// ADK Version: ${ADK_VERSION}
// Generated at: ${new Date().toISOString()}
////////////////////////////////////////////////////////

type SDKEvent = import("@botpress/client").Event;
type Events = import("@botpress/runtime/_types/events").Events;

type Event<TName extends keyof Events> = Omit<SDKEvent, "payload" | "type"> & {
  type: TName;
  payload: Events[TName];
};

declare module "@botpress/runtime/_types/triggers" {
  // Map of trigger names to their properties
  export type Triggers = {
${triggersType}
  };
}
`

  // Write to trigger-types.d.ts in the .adk folder
  const triggerTypesPath = path.join(project.path, '.adk', 'trigger-types.d.ts')
  await createFile(triggerTypesPath, await formatCode(content))
}
